<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
import MainView from "./views/MainView.vue";

export default {
	components: {
		MainView
	},
	mounted() {
		let hubspotScript = document.createElement('script');
		hubspotScript.setAttribute('src', '//js.hs-scripts.com/3465262.js');
		hubspotScript.setAttribute('async', '');
		hubspotScript.setAttribute('defer', '');
		document.body.appendChild(hubspotScript);
	}
};
</script>
